import { render, staticRenderFns } from "./PricingDialog.vue?vue&type=template&id=d1c174b6"
import script from "./PricingDialog.vue?vue&type=script&lang=ts"
export * from "./PricingDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports